function create_html(product,variant) {
    var images = product.images;
    var content = product.body_html.replace(/<\/?[^>]+(>|$)/g, "").substr(0,50);
    var url = product.handle;
    var name = variant.title != 'Default Title' ? product.title+' '+variant.title : product.title;
    var price = parseFloat(variant.compare_at_price) > parseFloat(variant.price) ? '<del class="no-sale">'+money_format+(variant.compare_at_price)+'</del> <span class="price-sale">'+money_format+(variant.price)+'</span>':'<span class="price-sale">'+money_format+(variant.price)+'</span>';
    var sale_0ff = parseFloat(variant.compare_at_price) > parseFloat(variant.price) ? '<span class="sale">SALE</span>':'';
    var html =
    '<div class="col-md-3 col-sm-4 col-xs-12">'+
        '<div class="content-product clear-all"> ' +
            '<div class="image-action"> ' +
                '<div class="badge">' +
                    sale_0ff +
                '</div> ' +
                '<img src="'+images[0].src+'" alt="'+name+'"> ' +
                '<div class="action">' +
                    '<ul class="clear-all"> ' +
                        '<li class="view-cart"><a href="/cart"><i class="fa fa-refresh fa-spin"></i></a></li> ' +
                        '<li data-balloon="Add to cart" data-balloon-pos="up"><a href="#" data-variant="'+variant.id+'" class="add-to-cart"><i class="fa fa-opencart"></i></a></li> ' +
                        '<li data-balloon="Remove from wishlist" data-balloon-pos="up"><a  data-variant-id="'+variant.id+'"  class="in-wished"><i class="fa fa-heart"></i></a></li> ' +
                    '</ul> ' +
                '</div> ' +
            '</div> ' +
            '<div class="info-product"> ' +
                '<h4 title="'+name+'"><a href="/products/'+url+'/?variant='+variant.id+'">'+name+'</a></h4> ' +
                '<p>'+price+'</p> ' +
            '</div>' +
        '</div>' +
    '</div>';
    return html;
}
if ($('.wishlist-container').length > 0) {
    if(customer_id != '') {
        $.ajax({
            url: 'https://farost.net/appshopify/wishlist/wishlist.php',
            type: 'GET',
            data: {
                customer_id: customer_id,
                shop: domain,
                type: 'get'
            },
            dataType: 'json'
        }).always(function (response) {
            var products = response.data;
            var wish = wishlists.split(',');
            var results = [];
            if(products.length > 0) {
                $('.isotope-wish').empty();
                $.each(products, function (i, e) {
                    if (results == null) {
                        results.push(products[0]);
                    } else {
                        var isset = true;
                        $.each(results, function (j, p) {
                            if (e.id.toString() == p.id.toString()) {
                                isset = false;
                                return false;
                            }
                        });
                        if (isset) {
                            results.push(e);
                        }
                    }
                });
                products = results;
                for (var i = 0; i <= products.length; i++) {
                    var product = products[i];
                    if (typeof product !== "undefined") {
                        if (product.variants.length > 1) {
                            $.each(product.variants, function (i, e) {
                                $.each(wish, function (j, w) {
                                    if (e.id.toString() == w) {
                                        var html = create_html(product, e);
                                        $('.isotope-wish').append(html);
                                    }
                                })
                            });
                        } else {
                            var html = create_html(product, product.variants[0]);
                            $('.isotope-wish').append(html);
                        }
                    }
                }
                setInterval(function(){
                    $('.isotope-wish').isotope({filter:'*'});
                },1000);
            }
        });
    }
}
$(document).on('click', 'a.add-wishlist', function(e) {
    e.preventDefault();
    var $this = $(this);
    var variant_id = $this.attr('data-variant');
    if($(this).hasClass('add-wishlist')){
        $(this).find('i').removeClass('fa-heart-o').addClass('fa-heart');
    }
    if (customer_id == "") {
        return;
    }
    var data = {
        customer_id: customer_id,
        variant_id: variant_id,
        type: 'update',
        shop: domain
    };
    $.ajax({
        url: 'https://farost.net/appshopify/wishlist/wishlist.php',
        type: 'POST',
        data: data,
        dataType: 'json'
    }).always(function(response) {
        if (response.message == "success") {
            if (response.type == "add") {
                $(document).find('[data-variant="'+variant_id+'"]').each(function(){
                    console.log(response);
                })
            }
            if (response.type == "remove") {
                $(document).find('[data-variant="'+variant_id+'"]').each(function(){
                    if($(this).hasClass('add-wishlist')){
                        $(this).find('i').removeClass('fa-heart').addClass('fa-heart-o');
                    }
                })
            }
        }
    });
});
$(document).on('click', 'a.in-wished', function(e) {
    e.preventDefault();
    var $this = $(this);
    var variant_id = $this.attr('data-variant-id');
    if (customer_id == "") {
        return;
    }
    var data = {
        customer_id: customer_id,
        variant_id: variant_id,
        type: 'update',
        shop: domain
    };
    $.ajax({
        url: 'https://farost.net/appshopify/wishlist/wishlist.php',
        type: 'POST',
        data: data,
        dataType: 'json'
    }).always(function(response) {
        if (response.message == "success") {
            if (response.type == "remove") {
                $this.parents('.col-xs-12').fadeOut('slow').remove();
                window.location = window.location;
            }
        }
    });
});
$(document).on('click', 'a.clear-wishlist', function(e) {
    e.preventDefault();
    var that = $(this);
    var data = {
        customer_id: customer_id,
        type: 'delete-all',
        shop: domain
    };
    $.ajax({
        url: 'https://farost.net/appshopify/wishlist/wishlist.php',
        type: 'POST',
        data: data,
        dataType: 'json'
    }).always(function(response) {
        if (response.message == "success") {
            window.location = window.location;
        }
    });
});